import { createContext, useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useListFeatureFlags } from '../../query-hooks/feature-flags';

export const FeatureFlagsContext = createContext();

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

const resolveFeatureFlag = ({ flagName, isLoading, serverFeatureFlags } = {}) => {
  if (isLoading) {
    return false;
  }
  return serverFeatureFlags?.[flagName] ?? false;
};

const FeatureFlagsProvider = ({ children, enabled = true }) => {
  const { data: serverFeatureFlags, isFetched } = useListFeatureFlags({ enabled });
  const isLoadingFeatureFlags = Boolean(!serverFeatureFlags && !isFetched);
  const getFlagValue = useCallback(
    flagName =>
      resolveFeatureFlag({
        flagName,
        isLoading: isLoadingFeatureFlags,
        serverFeatureFlags,
      }),
    [isLoadingFeatureFlags, serverFeatureFlags]
  );
  const contextValue = useMemo(
    () => ({ getFlagValue, isLoading: isLoadingFeatureFlags }),
    [getFlagValue, isLoadingFeatureFlags]
  );

  return <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>;
};

FeatureFlagsProvider.propTypes = {
  children: PropTypes?.node,
  enabled: PropTypes?.bool,
};

export default FeatureFlagsProvider;
